import { ShoppingBag, Link2, Settings2 } from "lucide-react";
import { Reveal } from "@/lib/motion";

const CARDS = [
  {
    icon: ShoppingBag,
    title: "Order",
    text: "Order your Tap Review NFC Stand.",
  },
  {
    icon: Link2,
    title: "Provide your Google Review link",
    text: "Provide your business's Google Review URL during checkout.",
  },
  {
    icon: Settings2,
    title: "We configure your NFC stand",
    text: "We configure the NFC stand with your Google Review link before shipping.",
  },
];

export const HowItWorks = () => (
  <section
    id="how-it-works"
    className="scroll-mt-24 bg-white py-24 md:py-32"
    data-testid="how-it-works-section"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="text-overline">How it works</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
          Ready for your business in three steps.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.12}>
            <div className="group h-full rounded-3xl border border-black/5 bg-sand p-8 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-transform duration-300 hover:-translate-y-1 md:p-10">
              <div className="flex items-center gap-4">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ink text-white">
                  <c.icon className="h-5 w-5" strokeWidth={1.6} />
                </span>
                <span className="text-sm font-semibold tracking-[0.14em] text-ink/40">
                  0{i + 1}
                </span>
              </div>
              <h3 className="mt-8 font-display text-2xl font-medium tracking-tight text-ink">
                {c.title}
              </h3>
              <p className="mt-3 leading-relaxed text-graphite">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.36}>
        <div className="mt-6 flex flex-col items-center gap-4 rounded-3xl border border-black/5 bg-sand p-6 text-center md:mt-8 md:flex-row md:justify-between md:p-8 md:text-left">
          <div>
            <p className="text-overline">Ready to use</p>
            <p className="mt-2 font-display text-xl font-medium tracking-tight text-ink">
              Your stand arrives configured — just place it on your counter.
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm font-medium text-graphite">
            <span>Order</span>
            <span className="text-ink/30">→</span>
            <span>Provide your link</span>
            <span className="text-ink/30">→</span>
            <span>We configure it</span>
            <span className="text-ink/30">→</span>
            <span className="text-ink">Ready to use</span>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
